import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Tabs from '../../../../components/Tabs';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/early-years/layoutProps';

import styles from './index.module.scss';

import eliza from './eliza@small.jpg';
import freda from './freda@small.jpg';
import irene from './irene@small.jpg';
import michelle from './michelle@small.jpg';

const tabs = ['黃庭芳', '郭淑瑩', '梁翠嫦', 'Michelle Chu'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="zh" pageKey="leadership-team">
        <h1>領導層</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <h3>黃庭芳</h3>
            <p>總校長</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={eliza} alt="Eliza Wong" />
              </div>
              <div>
                <p>
                  黃庭芳總校長從事教育工作至今33年，她於1997年加入京斯敦國際學校，出任幼兒園及幼稚園主任一職，於2001年獲晉升為幼稚園校長，於2008年兼任小學校長。同年後期更獲校董會躍升為京斯敦國際學校幼稚園及小學的總校長。在2009年至今，更出任一條龍中學International
                  College of Hong Kong的校董會成員。
                </p>
                <p>
                  黃校長致力參與學校發展，以配合供不應求的學位需要，她全程參與京斯敦國際學校的建設，協助京斯敦於2001年及2010年先後開辦了低小和高小兩所小學，帶領學校邁步向前。在教與學方面，黃校長早於小學開辦前已接受IBPYP課程的培訓，致力帶領學校的課程發展，她過往曾參與大大小小的IB會議及工作坊，先後到過瑞士、澳洲、泰國、上海、北京、越南、印度、新加坡等國家，與不同的IB學校領導層作學術上的交流。此外，她也大力推動在京斯敦國際學校裡的中文課程發展，使之成為高水平、獨一無二的京斯敦中文課程。
                </p>
              </div>
            </div>
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <h3>郭淑瑩</h3>
            <p>京斯敦幼兒園中文科主任</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={freda} alt="Freda Kwok" />
              </div>
              <div>
                <p>
                  郭主任在香港出生和成長，小時的夢想是當一名老師，中學預科畢業後在一所私立幼稚園作教師，確定自己一生的使命就是在幼兒教育。
                </p>
                <p>
                  1987年在香港理工學院(現正名為香港理工大學)接受幼兒教育的訓練，成為一名幼兒工作員。在1989年郭主任婚後計劃生育，為子女得到最好的照顧，暫時放下熱愛的工作，專心照顧家庭。
                </p>
                <p>
                  1998年子女升讀小學後，郭主任重投幼兒教育，並受聘於京斯敦幼兒園。及後在香港浸會大學持續進修，2000年在社會福利署註冊成為一名幼兒園主任，2005年在香港教育學院(現正名為香港教育大學)畢業，取得幼稚園教育證書。
                </p>
                <p>
                  2006年第三名幼子出生，兒子在2007入讀京斯敦親子班至2017年畢業於京斯敦國際學校，十年期間郭主任同時為京斯敦的家長。
                </p>
                <p>
                  每一天在京斯敦迎接著一張一張可愛的笑臉上學，是郭主任每天工作的動力，這些天真的笑臉都讓她不能忘記，孩子們從自己的家庭去認識自己身處的世界，第一步就在這裏開始，她很高興能見證著每一顆小生命茁壯成長。
                </p>
                <p>
                  郭主任在香港出生和成長，小時的夢想是當一名老師，中學預科畢業後在一所私立幼稚園作教師，確定自己一生的使命就是在幼兒教育。
                </p>
              </div>
            </div>
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <h3>梁翠嫦</h3>
            <p>幼稚園中文主任</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={irene} alt="Irene Leung" />
              </div>
              <div>
                <p>梁主任出生於香港，畢業於香港教育大學後一直從事幼兒教育工作，對香港本土文化及教育制度非常熟悉。</p>
                <p>
                  梁主任於2002年開始加入京斯敦國際學校擔任幼稚園的中文主任。加入京斯敦後，她努力研習國際文憑組織小學項目的精髓，參與不同的培訓，協助改革幼稚園的中文課程，配合推行雙語體系的探究單元計劃，為幼小的學生提供具意義、有趣味和挑戰性的學習經驗；融合不同的文化，以及多樣化的學習旅程。她非常重視幼兒的興趣，欣賞每個孩子的獨特之處，鼓勵他們在學習中進行反思，為培養學生具備國際情懷提供支援。
                </p>
                <p>
                  梁主任有一個二十多歲的兒子，作為一位母親，她相信最了解孩子的一定是爸爸媽媽。孩子的世界，由家庭與學校組成，所以她對家校合作十分重視。京斯敦是一家能欣賞孩子獨特之處的學校，在家校的衷誠合作之下，孩子的潛能定能盡情發揮，這正是她對教育的祈望！
                </p>
              </div>
            </div>
          </React.Fragment>
        )}
        {tab === 3 && (
          <React.Fragment>
            <h3>Ms. Michelle Chu</h3>
            <p>國際文憑小學文憑課程協調員/英文科主任 (京斯敦幼兒園/京斯敦國際幼稚園)</p>
            <div className={styles.container}>
              <div className={styles.image}>
                <img src={michelle} alt="Michelle Chu" />
              </div>
              <div>
                <p>
                  Ms. Michelle
                  Chu來自紐西蘭，於二零零二年移居香港，開始幼兒教育事業的生涯。Michelle曾於香港不同幼稚園工作，二零一零年加入京斯敦，擔當班主任一職，隨後晉升為小學文憑課程協調員及英語科主任。Michelle帶領京斯敦經歷兩次國際文憑評核，未來會繼續致力發展及改善校內課程。
                </p>
                <p>
                  Michelle持有紐西蘭梅西大學的文學學士學位，擁有香港教育大學合格幼稚園教師資格，以及香港大學幼兒教育學位教師教育文憑，並於最近完成香港浸會大學幼稚園校長證書課程。
                </p>
                <p>
                  Michelle同時為京斯敦的家長。她安排兩位孩子入讀京斯敦，以確保他們能夠接受雙語教育，發展中英語文能力；亦希望孩子能在京斯敦的國際文憑課程及小班教學模式下全面發展，培養國際視野。
                </p>
              </div>
            </div>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
